<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :search="search"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="getColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>客户中心</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            single-line
            hide-details
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="0px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                添加
              </v-btn>
            </template>
            <validation-observer
              ref="observer"
            >
              <form @submit.prevent="submit">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-dialog
                          v-model="dialog"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <v-card>
                            <v-toolbar
                              dark
                              color="primary"
                            >
                              <v-btn
                                icon
                                dark
                                @click="dialog = false"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                              <v-spacer />
                              <v-toolbar-items>
                                <v-btn
                                  dark
                                  color="success"
                                  @click="save"
                                >
                                  Save
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-divider />

                            <v-stepper v-model="e1">
                              <v-stepper-header>
                                <v-stepper-step
                                  :complete="e1 > 1"
                                  step="1"
                                >
                                  基本信息
                                </v-stepper-step>

                                <v-divider />

                                <v-stepper-step
                                  :complete="e1 > 2"
                                  step="2"
                                >
                                  扩展信息
                                </v-stepper-step>

                                <v-divider />

                                <v-stepper-step step="3">
                                  分配
                                </v-stepper-step>
                              </v-stepper-header>

                              <v-stepper-items>
                                <v-stepper-content step="1">
                                  <v-card
                                    class="mb-12"
                                    color="red lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="公司名称"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.company"
                                            :error-messages="errors"
                                            label="公司名称"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户姓名"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.name"
                                            :error-messages="errors"
                                            label="客户姓名"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户电话"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.phone"
                                            :error-messages="errors"
                                            label="客户电话"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="其它联系方式"
                                        >
                                          <v-textarea
                                            v-model="editedItem.other_phone"
                                            :error-messages="errors"
                                            label="其它联系方式"
                                            rows="2"
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="概况描述"
                                        >
                                          <v-textarea
                                            v-model="editedItem.description"
                                            :error-messages="errors"
                                            label="概况描述"
                                            rows="3"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    color="primary"
                                    @click="e1 = 2"
                                  >
                                    下一步
                                  </v-btn>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                  <v-card
                                    class="mb-12"
                                    color="green lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6 white--text"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户来源"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.customer_source"
                                            :error-messages="errors"
                                            label="客户来源"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="线索来源"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.source"
                                            :error-messages="errors"
                                            label="线索来源"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="搜索词"
                                          rules="required"
                                        >
                                          <v-text-field
                                            v-model="editedItem.search_keyword"
                                            :error-messages="errors"
                                            label="搜索词"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="关键词"
                                        >
                                          <v-text-field
                                            v-model="editedItem.keyword"
                                            :error-messages="errors"
                                            label="关键词"
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="客户类型"
                                        >
                                          <v-radio-group
                                            v-model="editedItem.type"
                                            :error-messages="errors"
                                            mandatory
                                            row
                                            label="客户类型"
                                          >
                                            <v-radio
                                              label="A类客户"
                                              value="Ａ"
                                            />
                                            <v-radio
                                              label="B类客户"
                                              value="Ｂ"
                                            />
                                            <v-radio
                                              label="C类客户"
                                              value="C"
                                            />
                                          </v-radio-group>
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="结果（状态）"
                                        >
                                          <v-radio-group
                                            v-model="editedItem.status"
                                            :error-messages="errors"
                                            mandatory
                                            row
                                            label="结果（状态）"
                                          >
                                            <v-radio
                                              label="线索"
                                              value="0"
                                            />
                                            <v-radio
                                              label="待定"
                                              value="1"
                                            />
                                            <v-radio
                                              label="无效"
                                              value="2"
                                            />
                                            <v-radio
                                              label="有效约见"
                                              value="3"
                                            />
                                            <v-radio
                                              label="高意向"
                                              value="4"
                                            />
                                            <v-radio
                                              label="低意向"
                                              value="5"
                                            />
                                            <v-radio
                                              label="签约"
                                              value="6"
                                            />
                                            <v-radio
                                              label="输单"
                                              value="7"
                                            />
                                          </v-radio-group>
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="无效原因"
                                        >
                                          <v-textarea
                                            v-model="editedItem.remarks"
                                            :error-messages="errors"
                                            label="无效原因"
                                            rows="2"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    class="ma-2"
                                    @click="e1 = 1"
                                  >
                                    上一步
                                  </v-btn>
                                  <v-btn
                                    class="ma-2"
                                    color="primary"
                                    @click="e1 = 3"
                                  >
                                    下一步
                                  </v-btn>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                  <v-card
                                    class="mb-12"
                                    color="blue lighten-5"
                                  >
                                    <v-row
                                      class="spacing-playground pa-6 white--text"
                                    >
                                      <v-col
                                        cols="12"
                                        md="6"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="商务负责人"
                                          rules="required"
                                        >
                                          <v-select
                                            v-model="editedItem.user_id"
                                            :items="items"
                                            :menu-props="{ top: true, offsetY: true }"
                                            :error-messages="errors"
                                            item-text="name"
                                            item-value="id"
                                            label="商务负责人"
                                            required
                                          />
                                        </validation-provider>
                                      </v-col>
                                      <v-col
                                        cols="24"
                                        md="12"
                                      >
                                        <validation-provider
                                          v-slot="{ errors }"
                                          name="生命周期日志"
                                        >
                                          <v-textarea
                                            v-model="editedItem.life_cycle"
                                            :error-messages="errors"
                                            label="生命周期日志"
                                            hint="从分配任务到签单过程中的事件记录到生命周期中，换行分割"
                                            rows="7"
                                          />
                                        </validation-provider>
                                      </v-col>
                                    </v-row>
                                  </v-card>
                                  <v-alert
                                    outlined
                                    color="purple"
                                  >
                                    填写必填信息后，点击右上角的【save】提交
                                  </v-alert>
                                  <v-btn
                                    class="ma-2"
                                    @click="e1 = 2"
                                  >
                                    上一步
                                  </v-btn>
                                </v-stepper-content>
                              </v-stepper-items>
                            </v-stepper>
                          </v-card>
                        </v-dialog>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </form>
            </validation-observer>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="300px"
          >
            <v-card>
              <v-card-title
                class="headline"
              >
                请确认是否删除?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  确定
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template
        v-slot:item.actions="{ item }"
      >
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <!--<v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />-->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  extend('required', {
    ...required,
    message: '{_field_} 不能为空',
  })

  export default {
    name: 'CustomerView',
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data: () => ({
      e1: 1,
      radios: 1,
      search: '',
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      dialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      roleList: [],
      headers: [
        {
          text: '序号',
          align: 'center',
          value: 'id',
          width: '85',
        },
        { text: '客户来源', value: 'customer_source', width: '120' },
        { text: '线索来源', value: 'source', width: '120' },
        { text: '联系人', value: 'name', sortable: false, width: '100' },
        { text: '电话', value: 'phone', sortable: false, width: '120' },
        { text: '其他联系方式', value: 'other_phone', width: '160' },
        { text: '公司名称', value: 'company', sortable: false, width: '150' },
        { text: '概况描述', value: 'description', sortable: false, width: '150' },
        { text: '分配AE', value: 'auther', width: '110' },
        { text: '搜索词', value: 'search_keyword', width: '120' },
        { text: '关键词', value: 'keyword', width: '120' },
        { text: '结果', value: 'status', width: '100' },
        { text: '初步判断', value: 'type', width: '120' },
        { text: '无效原因', value: 'remarks', sortable: false, width: '150' },
        { text: '操作', value: 'actions', sortable: false, width: '100' },
      ],
      desserts: [],
      editedIndex: -1,
      roles: '',
      items: [],
      editedItem: {
        name: '',
        company: '',
        phone: '',
        other_phone: '',
        description: '',
        customer_source: '',
        source: '',
        search_keyword: '',
        keyword: '',
        type: '',
        status: '',
        remarks: '',
        auther: '',
        life_cycle: '',
      },
      defaultItem: {
        name: '',
        company: '',
        phone: '',
        other_phone: '',
        description: '',
        customer_source: '',
        source: '',
        search_keyword: '',
        keyword: '',
        type: '',
        status: '',
        remarks: '',
        auther: '',
        life_cycle: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '录入客户信息' : '修改客户信息'
      },
    },

    watch: {
      dialog (val) {
        if (val === true) {
          if (this.editedIndex === -1) {
            // this.roles = 'sale'
          }
        }
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // get Customer
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/list')
          .then(response => {
            if (response.status === 200) {
              this.desserts = response.data.data.data
              this.desserts.map((item, i, arr) => {
                // 0线索，1待定，2无效，3有效约见，4高意向，5低意向，6签约，7输单
                switch (item.status) {
                  case 0:
                    item.status = '线索'
                    break
                  case 1:
                    item.status = '待定'
                    break
                  case 2:
                    item.status = '无效'
                    break
                  case 3:
                    item.status = '有效约见'
                    break
                  case 4:
                    item.status = '高意向'
                    break
                  case 5:
                    item.status = '低意向'
                    break
                  case 6:
                    item.status = '签约'
                    break
                  case 7:
                    item.status = '输单'
                    break
                }
              })
              // console.log(this.desserts)
            }
          })
          .catch(error => {
            console.log(error)
          })
        // 获取销售列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/customer/admins')
          .then(response => {
            if (response.status === 200) {
              this.items = response.data.data.data
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // this.editedItem.status = (this.editedItem.status === '启用') ? '1' : '0'
        console.log(this.editedItem.status)
        switch (item.status) {
          case '线索':
            this.editedItem.status = 0
            break
          case '待定':
            this.editedItem.status = 1
            break
          case '无效':
            this.editedItem.status = 2
            break
          case '有效约见':
            this.editedItem.status = 3
            break
          case '高意向':
            this.editedItem.status = 4
            break
          case '低意向':
            this.editedItem.status = 5
            break
          case '签约':
            this.editedItem.status = 6
            break
          case '输单':
            this.editedItem.status = 7
            break
        }
        console.log(this.editedItem)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/customer/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts.splice(this.editedIndex, 1)
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      submit () {
        this.$refs.observer.validate()
        // console.log(this.editedItem)
        if (this.editedItem.company !== '' && this.editedItem.name !== '' && this.editedItem.phone !== '') {
          const item = this.editedItem
          const _editedIndex = this.editedIndex
          const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/customer/create' : process.env.VUE_APP_BASE_API + '/customer/update/' + item.id
          this.editedItem.roles = this.roles
          axios
            .post(url, this.editedItem)
            .then(response => {
              if (response.data.code === 20000) {
                switch (item.status) {
                  case '0':
                    item.status = '线索'
                    break
                  case '1':
                    item.status = '待定'
                    break
                  case '2':
                    item.status = '无效'
                    break
                  case '3':
                    item.status = '有效约见'
                    break
                  case '4':
                    item.status = '高意向'
                    break
                  case '5':
                    item.status = '低意向'
                    break
                  case '6':
                    item.status = '签约'
                    break
                  case '7':
                    item.status = '输单'
                    break
                }
                item.id = response.data.data
                if (_editedIndex > -1) {
                  Object.assign(this.desserts[_editedIndex], item)
                } else {
                  this.desserts.push(item)
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
          this.close()
        }
      },

      save () {
        this.$refs.observer.validate()
        /* const item = this.editedItem
        const _editedIndex = this.editedIndex
        const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/admins/create' : process.env.VUE_APP_BASE_API + '/admins/update/' + item.id
        const _roleTmp = this.roleTmp
        this.editedItem.roles = this.roles
        axios
          .post(url, this.editedItem)
          .then(response => {
            if (response.data.code === 20000) {
              item.status = (item.status === '1') ? '启用' : '禁用'
              item.id = response.data.data
              item.roles = (item.roles || '').split(',')
              item.role_name = [_roleTmp[item.roles]]
              console.log(item)
              if (_editedIndex > -1) {
                Object.assign(this.desserts[_editedIndex], item)
              } else {
                this.desserts.push(item)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.close() */
        this.submit()
      },

      getColor (calories) {
        if (calories === '无效' || calories === '输单') return 'red'
        else return 'green'
      },

    },
  }
</script>
